import { format } from 'date-fns'
import moment from 'moment'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { jobsActions } from 'src/ducks/actions'
import { getStatistiscs } from 'src/ducks/selectors'
import headers from './headers'

const Month = () => {

  const [tableLoading, setTableLoading] = useState(true)
  const dispatch = useDispatch()
  const statisticsList = useSelector(getStatistiscs())
  const formatDate = 'MM/dd/yyyy'

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchServices = useCallback(() => {
    setTableLoading(true)
    const fistDayOfMonth = moment().startOf('month').toDate()
    const lastDayOfMonth = moment().endOf('month').toDate()

    dispatch(jobsActions.fetchJobsCounts({
      searchParams: {
        startDate: format(fistDayOfMonth, formatDate),
        endDate: format(lastDayOfMonth, formatDate)
      }
    }, (_succ: boolean) => {
      setTableLoading(false)
    }))
  }, [])

  useEffect(() => {
    fetchServices()
  }, [dispatch, fetchServices])

  return (
    <Table
      headers={headers}
      loading={tableLoading}
      hasPagination={false}
    >
      {statisticsList ?? []}
    </Table>
  )
}

export default Month
